

const UserList = ({ deletedTasks }) => {
  return (
    <>
      <div>
        <div className="container py-5 text-center">
          <div
            className="bg-light shadow rounded-2 py-2"
            style={{ minHeight: "335px" }}
          >
            <h1 className="d-inline-block border-bottom border-2 border-dark">
              Deleted Tasks
            </h1>

            {deletedTasks.length > 0 ? (
              <ul className="py-2 px-2">
                {deletedTasks.map((item, index) => (
                  <li
                    className="d-flex justify-content-between align-items-center fs-4 py-2 px-3 mb-2"
                    style={{
                      color: "gray",
                      borderBottom: "1px solid gray",
                    }}
                    key={index}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            ) : (
              <div className="mt-5 d-flex align-items-center justify-content-center">
                <p>No tasks have been deleted yet.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserList;
